import {UntypedFormControl, ValidatorFn, AsyncValidatorFn, FormControl} from '@angular/forms';
import {FormElement} from '../../models/WebFormTemplate';

export class CustomFormControl extends UntypedFormControl {
  element: FormElement;

  constructor(
    value: any = '',
    template: FormElement,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super(value, validatorOrOpts, asyncValidator);
    this.element = template;
  }

  isRequired(): boolean {
    if (this.element.regex) { return true; }
    if (this.element.syncValidators && this.element.syncValidators.includes('required')) { return true; }
    return this.element.asyncValidators && this.element.asyncValidators.length > 0;
  }

  get AsTyped(): FormControl {
    return this;
  }
}
